import api from '../client';

export const CalendarService = {
  getAvailableCalendars: () => api.get('/calendar/available-calendars'),
  getEvents: (params) => api.get('/calendar/events', { params }),
  getEventById: (id) => api.get(`/calendar/events/${id}`),
  getPendingRsvps: () => api.get('/calendar/pending-rsvps'),
  getRsvpHistory: () => api.get('/calendar/rsvp-history'),
  getEventParticipants: (eventId) => api.get(`/calendar/events/${eventId}/participants`),
  createEvent: (data) => api.post('/calendar/events', data),
  updateEvent: (id, data) => api.patch(`/calendar/events/${id}`, data),
  deleteEvent: (id) => api.delete(`/calendar/events/${id}`),
  getPermissions: () => api.get('/calendar/permissions'),
  createPermission: (data) => api.post('/calendar/permissions', data),
  deletePermission: (id) => api.delete(`/calendar/permissions/${id}`),
  getTaskDeadlines: (params) => {
    console.log('[CalendarService] getTaskDeadlines called with params:', params);
    return api.get('/calendar/task-deadlines', { params });
  },
  getBirthdays: (params) => {
    console.log('[CalendarService] getBirthdays called with params:', params);
    return api.get('/calendar/birthdays', { params });
  },
  updateLinkedTaskDecision: (eventId, linkId, data) => api.patch(`/calendar/events/${eventId}/linked-tasks/${linkId}`, data),
  updateLinkedProjectDecision: (eventId, linkId, data) => api.patch(`/calendar/events/${eventId}/linked-projects/${linkId}`, data),
  getCaldavMe: () => api.get('/calendar/caldav/me'),
  resetCaldavPassword: () => api.post('/calendar/caldav/reset-password'),
};
